import { isNil } from "lodash";
import PropTypes from "prop-types";
import {
  checkedFieldOf,
  fieldsForValidator,
  lookalikeValidator,
} from "./checked-fields";
import { fillTemplate } from "./workshop-view";

const WorkshopCheckedCard = ({
  slot,
  savedIn,
  rule,
  savedRule,
  checkedFields,
  ruleLabel,
  labels,
  saving,
  onUse,
  onCheck,
}) => {
  const field = checkedFieldOf(checkedFields, savedIn);

  if (!isNil(field)) {
    const check = ruleLabel(field.validator);
    if (savedRule === field.validator && rule === field.validator)
      return (
        <div role="status" className="workshop-needs workshop-needs--ok">
          <strong className="workshop-needs__title">
            {fillTemplate(labels.CHECKED, { check })}
          </strong>
        </div>
      );
    return (
      <div role="status" className="workshop-needs workshop-needs--warn">
        <strong className="workshop-needs__title">
          {fillTemplate(labels.NO_CHECK, { check })}
        </strong>
        {rule === field.validator ? (
          <span className="workshop-needs__line">{labels.TO_APPLY}</span>
        ) : (
          <button
            type="button"
            className="workshop-needs__action"
            disabled={saving}
            onClick={() => onCheck(field.validator)}
          >
            {labels.SET_CHECK}
          </button>
        )}
      </div>
    );
  }

  const validator = lookalikeValidator(slot, savedIn);
  const candidates = fieldsForValidator(checkedFields, validator);
  if (isNil(validator) || !candidates.length) return null;

  return (
    <div role="status" className="workshop-needs workshop-needs--warn">
      <strong className="workshop-needs__title">
        {fillTemplate(labels.SUGGEST, { check: ruleLabel(validator) })}
      </strong>
      <div className="workshop-needs__choices">
        {candidates.map((candidate) => (
          <button
            key={candidate.path}
            type="button"
            className="workshop-needs__choice"
            disabled={saving}
            onClick={() => onUse(candidate.path)}
          >
            {candidate.label}
          </button>
        ))}
      </div>
    </div>
  );
};

WorkshopCheckedCard.propTypes = {
  slot: PropTypes.object.isRequired,
  savedIn: PropTypes.string,
  rule: PropTypes.string,
  savedRule: PropTypes.string,
  checkedFields: PropTypes.arrayOf(PropTypes.object),
  ruleLabel: PropTypes.func.isRequired,
  labels: PropTypes.object.isRequired,
  saving: PropTypes.bool,
  onUse: PropTypes.func.isRequired,
  onCheck: PropTypes.func.isRequired,
};

WorkshopCheckedCard.defaultProps = {
  savedIn: null,
  rule: null,
  savedRule: null,
  checkedFields: [],
  saving: false,
};

export default WorkshopCheckedCard;
